<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-22 
-->
<template>
  <div class="index">
    <div class="banner-mobile" @click="clickBanner(banner)" v-if="banner.img">
      <img :src="banner.img" />
    </div>
    <div class="banner-mobile" v-else></div>
    <div class="number-container" v-if="numberList.length">
      <div class="number-list" v-if="numberList.length > 2">
        <swiper :options="swiperOption" ref="number-swiper">
          <swiper-slide class="swiper-no-swiping" v-for="item,index in numberList" :key="index">
            <div class="number-item">
              <div class="p1">
                <span class="sp1">{{item.number}}</span>
                <span class="sp2">{{item.unit}}</span>
              </div>
              <div class="p2">{{item.name}}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="number-list number-list2" v-else>
        <div class="number-item" v-for="item,index in numberList" :key="index">
          <div class="p1">
            <span class="sp1">{{item.number}}</span>
            <span class="sp2">{{item.unit}}</span>
          </div>
          <div class="p2">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="index-container">
      <div class="page-view" v-if="mainPageContent.length">
        <div class="page-title">
          <p class="p1">会+展+榜 三大版块</p>
          <p class="p2">CONFERENCE+EXHIBITION+AWARDS</p>
        </div>
        <div class="ecological">
          <div class="item" v-for="item,index in mainPageContent" :key="index">
            <div class="item-top">
              <div class="img-cnt">
                <img :src="item.imgPath | logo_show" class="bg-img">
              </div>
              <div class="title">
                <div v-if="language == 'zh'" v-html="item.showPageTitle"></div>
                <div v-else v-html="item.showEnPageTitle"></div>
              </div>
            </div>
            <div class="item-cnt">
              <img :src="static_img_url + `pic/sort`+(index + 1)+`.png`" class="sort-img" />
              <div class="desc">
                <div v-if="language == 'zh'" v-html="item.showContent"></div>
                <div v-else v-html="item.showEnContent"></div>
              </div>
              <div class="more-link" @click="handleClickPage(item.id, item.type)">{{'了解更多' | dealLanguage('More')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-view" v-if="guestDtos.length">
        <div class="page-title">
          <p class="p1">展会嘉宾</p>
          <p class="p2">SPEAKERS</p>
        </div>
        <div class="speakers">
          <speaker-item v-for="item,index in guestDtos" :key="index" :itemDetail="item"></speaker-item>
        </div>
        <!-- <div class="page-more">
          <div class="more-link" @click="handleChangeRoute('guests', '更多嘉宾')">更多嘉宾</div>
        </div> -->
      </div>
      <div class="page-view" v-if="activityExhibitionAreas.length">
        <div class="page-title">
          <p class="p1">特色展区</p>
          <p class="p2">FEATURED EXHIBITION AREA</p>
        </div>
        <div class="area">
          <div class="area-item" v-for="item,index in activityExhibitionAreas" :key="index" @click="handleClickAreas(item.id)">
            <div class="title">{{item.title | dealLanguage(item.enTitle)}}</div>
            <div class="mask2"></div>
            <img :src="item.imgPath | logo_show" class="bg-img" />
          </div>
        </div>
      </div>
      <div class="page-view" v-if="activityContentAppMiDtos.length">
        <div class="page-title">
          <p class="p1">新闻资讯</p>
          <p class="p2">NEWS</p>
        </div>
        <div class="news">
          <news-item v-for="item,index in activityContentAppMiDtos" :key="index" :itemDetail="item"></news-item>
        </div>
        <div class="page-more">
          <div class="more-link" @click="handleChangeRoute('newsList', '更多新闻资讯')">{{'更多新闻资讯' | dealLanguage('More News')}}</div>
        </div>
      </div>
      <div class="page-view" v-if="orgDtos.length">
        <div class="page-title">
          <p class="p1">精选展商</p>
          <p class="p2">EXHIBITORS</p>
        </div>
        <div class="entitys">
          <entity-item v-for="item,index in orgDtos" :key="index" :itemDetail="item"></entity-item>
        </div>
        <div class="page-more">
          <div class="more-link" @click="handleChangeRoute('exhibitors', '更多展商')">{{'更多展商' | dealLanguage('More Exhibitiors')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SpeakerItem from '@/components/index/speakerItem.vue'
import NewsItem from '@/components/index/newsItem.vue'
import EntityItem from '@/components/index/entityItem.vue'
import { getActExhibition } from '@/service/vbef'
import { Aadvertisement } from '@/service/app'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? this.activityDetail.name : this.activityDetail.enName,
    }
  },
  inject: ['globalInsertRecords', 'clickBanner', 'wxShare'],
  components: {
    SpeakerItem,
    NewsItem,
    EntityItem,
  },
  created() {
    this.getBanner()
    this.getActExhibition()
    this.dealMainPageContent()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('2025 VBEF未来医疗100强大会暨未来医疗医药生态展', '2025 VBEF Future Medical and Pharmaceutical Top 100 Conference and Future Medical and Pharmaceutical Ecological Exhibition'),
      linkurl: this.vbef_path,
      
    })
  },
  data() {
    return {
      numberList: [],
      actExhibitionDto: {},
      activityContentAppMiDtos: [],
      activityExhibitionAreas: [],
      guestDtos: [],
      orgDtos: [],
      banner: {},
      swiperOption: {
        slidesPerView: '2',
        autoplay: true,
        loop: true,
      },
      showMainPageContent: []
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      mainPageContent: (state) => state.mainPageContent,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    dealMainPageContent() {
      this.showMainPageContent = [...this.mainPageContent]
      this.showMainPageContent.map(a => {
        this.$set(a,'showPageTitle', a.pageTitle.replace(/\n/g, "<br>"))
        this.$set(a, 'showEnPageTitle', a.enPageTitle.replace(/\n/g, '<br>'))
        this.$set(a,'showContent', a.content.replace(/\n/g, "<br>"))
        this.$set(a, 'showEnContent', a.enContent.replace(/\n/g, '<br>'))
      })
    },
    async getBanner() {
      let res = await Aadvertisement({
        appAdPositionIds: this.language == 'zh' ? [67] : [123],
      })
      if (res.code == 0 && res.data.length) {
        this.$set(this.$data, 'banner', res.data[0])
      }
    },
    async getActExhibition() {
      let res = await getActExhibition({
        activityId: this.activityId,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'actExhibitionDto', res.data.actExhibitionDto)

        this.$set(this.$data, 'activityContentAppMiDtos', res.data.activityContentAppMiDtos)
        this.$set(this.$data, 'activityExhibitionAreas', res.data.activityExhibitionAreas)
        this.$set(this.$data, 'guestDtos', res.data.guestDtos)
        this.$set(this.$data, 'orgDtos', res.data.orgDtos)
        if(this.language == 'zh') {
          let fDtos = res.data.actExhibitionDto.featureJsonObjDtos || []
          if (fDtos.length > 0) {
            fDtos = fDtos.filter((item) => item.name && item.number)
          }
          this.$set(this.$data, 'numberList', fDtos)
        } else {
          let fDtos = res.data.actExhibitionDto.enFeatureJsonObjDtos || []
          if (fDtos.length > 0) {
            fDtos = fDtos.filter((item) => item.name && item.number)
          }
          this.$set(this.$data, 'numberList', fDtos)
        }
      }
    },
    handleClickPage(itemid, itemtype) {
      this.globalInsertRecords({
        contentId: itemid,
        contentType: 161,
        viewType: 1,
      })
      if (itemtype == 3) {
        window.location.href = 'https://vb100.vbdata.cn/Index/list'
      } else if (itemtype == 1) {
        this.$router.push({ name: 'agenda'})
      } else {
        this.$router.push({ name: 'exhibitionDesc', params: { id: 83 } })
      }
    },
    handleClickAreas(itemid) {
      this.globalInsertRecords({
        contentId: itemid,
        contentType: 162,
        viewType: 1,
      })
      this.$router.push({ name: 'exhibitionDesc', params: { id: 2 } })
      // let index = this.mainPageContent.findIndex((item) => item.type == 2)
      // if (index > -1) {
      //   let current_id = this.mainPageContent[index].id
      // }
    },
    handleChangeRoute(name, kw) {
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: kw,
      })
      this.$router.push({ name })
    },
  },
}
</script>
<style lang='stylus' scoped>
.banner-mobile
  height 5.38rem
  background #f0f0f0
  display flex
  justify-content center
  overflow hidden
  cursor pointer
  img
    width auto
    height 100%
.number-list
  background #FFF8F1
  padding 0.3rem 0
  &.number-list2
    display flex
    justify-content space-evenly
  .number-item
    text-align center
    padding 0 0.2rem
    .p1
      color #4E77DF
      line-height 0.72rem
      font-family 'DINMittelschriftStd'
      .sp1
        font-size 0.6rem
      .sp2
        font-size 0.4rem
    .p2
      font-size 0.26rem
      color #47515F
      line-height 0.36rem
      margin-top -0.1rem
.index-container
  padding 0 0.4rem 0.5rem
  .page-view
    padding-top 0.4rem
    &+.page-view
      padding-top 1rem
    .page-title
      text-align center
      .p1
        line-height 0.48rem
        font-size 0.36rem
        color #FA5A00
      .p2
        line-height 0.26rem
        font-size 0.26rem
        color #333333
        margin-top 0.2rem
  .more-link
    font-size 0.24rem
    color #4E77DF
    line-height 0.28rem
    border-bottom 0.02rem solid #4E77DF
    transition 0.3s
    cursor pointer
  .page-more
    margin-top 0.3rem
    display flex
    justify-content center
  .ecological
    margin-top 0.3rem
    .item
      background #FFFFFF
      box-shadow 0px 6px 16px 0px rgba(0, 0, 0, 0.1)
      cursor pointer
      &+div
        margin-top 0.4rem
      .item-top
        display flex
        align-items center
        .title
          font-size 0.32rem
          color #47515F
          line-height 0.5rem
          margin-left 0.2rem
          font-weight 700
        .img-cnt
          width 2.42rem
          height 2rem
          background #f0f0f0
          img
            width 100%
            height 100%
            object-fit cover
      .item-cnt
        padding 0.4rem 0.4rem 0.85rem
        position relative
        .sort-img
          position absolute
          height 0.4rem
          left 0.4rem
          top -0.2rem
          z-index 2
        .more-link
          position absolute
          bottom 0.26rem
          right 0.4rem
        .item-sort
          position absolute
        .desc
          font-size 0.26rem
          color #666666
          line-height 0.52rem
  .speakers
    margin-top 0.34rem
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 0.3rem 0.3rem
    & > :nth-child(2n+1)
      justify-self end
    & > :nth-child(2n)
      justify-self start
    >>> .speaker-item
      width 100%
      max-width 3.8rem
      min-width auto
      .speaker-img
        .header-img
          width 100%
          height calc(50vw - 0.55rem)
          max-height 3.8rem
        .comp-logo
          right -0.1rem
          bottom -0.1rem
          width 0.8rem
          height 0.8rem
        .name
          font-size 0.28rem
          line-height 0.18rem
          &::before
            width 0.04rem
            min-width 0.04rem
            max-width 0.04rem
            height 0.28rem
        .title
          font-size 0.26rem
          line-height 0.28rem
  .area
    margin-top 0.34rem
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 0.3rem 0.3rem
    .area-item
      height calc(60vw - 0.66rem)
      position relative
      overflow hidden
      .bg-img
        width 100%
        height 100%
        object-fit cover
      .mask2
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        background linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, rgba(216, 216, 216, 0) 100%)
        z-index 2
      .title
        position absolute
        left 0.2rem
        bottom 0.4rem
        right 0.2rem
        font-size 0.26rem
        color #FFFFFF
        line-height 0.28rem
        z-index 3
      &:active
        opacity 0.9
  .news
    margin-top 0.2rem
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 0.3rem 0.3rem
    & > :nth-child(2n+1)
      justify-self end
    & > :nth-child(2n)
      justify-self start
    >>> .news-item
      width 100%
      max-width 4rem
      min-width auto
      .news-img
        height calc(28.13vw - 0.31rem)
        max-height 2.25rem
      .news-content
        padding 0.2rem
        .title
          font-size 0.24rem
          line-height 0.36rem
        .time
          font-size 0.22rem
          line-height 0.22rem
          margin-top 0.2rem
  .entitys
    margin-top 0.3rem
    display grid
    grid-template-columns repeat(3, 1fr)
    grid-gap 0.3rem 0.3rem
    >>> .entity-item
      width auto
      max-width none
      height 0.9rem
</style>
